module.exports = __webpack_public_path__ + "static/media/right-arrow.1c7e644f.svg";